/**
 * Shared function room suite configuration & pricing details.
 * Extracted out of SocialBooking.jsx so BookingEnquiryModal.jsx can also
 * reference the same suite list (asking a modal to import from the
 * component that renders it would create a circular import).
 */

export const SUITES = [
  {
    id: 'portland',
    name: 'Portland Suite',
    capacity: 'Up to 300 people',
    baseHire: 150,
    bond: 100,
    djFrom: 250,
    cateringFrom: 7,
    costs: [
      {
        item: 'Bond (returnable)',
        price: 'From £100',
        note: 'Returned if the room and equipment are left clean and in good condition.',
      },
      { item: 'Room hire', price: 'From £150' },
      { item: 'DJ (optional)', price: 'From £250', note: 'Depends on which DJ is hired.' },
      { item: 'Catering', price: 'From £7 per person', note: 'Depends, it is mainly cold food, but some hot food exceptions can be discussed in person.' },
    ],
  },
  {
    id: 'kerry',
    name: 'Kerry Suite',
    capacity: 'Up to 80 people',
    baseHire: 100,
    bond: 100,
    djFrom: 250,
    cateringFrom: 7,
    costs: [
      { item: 'Bond (returnable)', price: 'From £100' },
      { item: 'Room hire', price: 'From £100' },
      { item: 'DJ', price: 'From £250' },
      { item: 'Catering', price: 'From £7 per person' },
    ],
  },
];